<template>
  <div class="latestScore">
    <div class="left">最新の得点</div>
    <div class="right">
      <span
        ><span class="green">{{ score }}</span
        >点</span
      >
      / {{ maxScore }}点
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CbtLatestScore',

  props: {
    score: {
      type: String,
      default: '0'
    },
    maxScore: {
      type: String,
      default: '0'
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.latestScore {
  margin-top: 24px;
  background-color: #fffccb;
  font-weight: 500;
  padding: 12px 0 16px;
  text-align: center;
  @include mixins.media() {
    display: flex;
    justify-content: center;
    align-items: baseline;
    padding-bottom: 12px;
  }
  .left {
    font-size: 1.4rem;
    line-height: 1.7;
    @include mixins.media() {
      line-height: 1;
      margin-right: 16px;
    }
  }
  .right {
    font-size: 1.6rem;
    letter-spacing: 0.03em;
    span {
      color: var.$color-main-text;
      line-height: 1;
      &.green {
        font-size: 2.4rem;
      }
    }
  }
}
</style>
